const LANGUAGE_LABELS: Record<string, string> = {
	en: 'English',
	vi: 'Vietnamese',
	zh: 'Chinese',
	ja: 'Japanese',
	ko: 'Korean',
	de: 'German',
	fr: 'French',
	es: 'Spanish',
	ar: 'Arabic',
	ru: 'Russian',
	it: 'Italian',
	pt: 'Portuguese',
	th: 'Thai',
	id: 'Indonesian',
	hi: 'Hindi',
	'en-us': 'English (US)',
	'en-uk': 'English (UK)',
	'en-gb': 'English (UK)',
	'vi-north': 'Vietnamese (North)',
	'vi-south': 'Vietnamese (South)',
}

export const getLanguageLabel = (code?: string | null) => {
	if (!code) return 'Unknown'
	const normalized = code.toLowerCase().trim().replace(/_/g, '-')
	return LANGUAGE_LABELS[normalized] ?? LANGUAGE_LABELS[code] ?? code.toUpperCase()
}
